"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Parser = void 0;
const util_1 = require("./util");
class Parser {
    constructor(opts) {
        this.parsers = opts.parsers;
    }
    parse(src) {
        return (0, util_1.loop)(this, (0, util_1.first)(this.parsers), src);
    }
}
exports.Parser = Parser;
